import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove caches deixados por versões antigas. O app atual não usa service worker,
// portanto nenhum cliente deve continuar preso a arquivos de um deploy anterior.
if ("serviceWorker" in navigator) {
  void navigator.serviceWorker.getRegistrations().then((registrations) =>
    Promise.all(registrations.map((registration) => registration.unregister())),
  );
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Elemento raiz da aplicação não encontrado");

createRoot(rootElement).render(<App />);
